import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '@/redux/store';

export const productPropagationSliceName = 'productPropagation';

export interface ProductPropagationState {
    selectedProductSignatures: string[];
}

const initialState: ProductPropagationState = {
    selectedProductSignatures: [],
};

const productPropagationSlice = createSlice({
    name: productPropagationSliceName,
    initialState,
    reducers: {
        setSelectedProductSignatures: (state, action: PayloadAction<string[]>) => {
            state.selectedProductSignatures = action.payload;
        },
        clearSelectedProductSignatures: (state) => {
            state.selectedProductSignatures = [];
        },
    },
});

export const getSelectedProductSignatures = (state: RootState): string[] =>
    state.productPropagation.selectedProductSignatures;

export const { setSelectedProductSignatures, clearSelectedProductSignatures } = productPropagationSlice.actions;
export default productPropagationSlice.reducer;
